module.exports = __webpack_public_path__ + "static/img/dba-online-course.59d8669.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personRain/dba-online-course.png
// module id = CW9g
// module chunks = 2